import { observable } from 'mobx';

import { SerializedData } from 'bernie-core';
import { Store } from 'bernie-plugin-mobx';

import { FlightsImagePlacardInformationLoaded } from '__generated__/api';
import FlightsImagePlacard = FlightsImagePlacardInformationLoaded.Fragment;

export class FreeCancellationStore extends Store {
  @observable public freeCancellation: FlightsImagePlacard;

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }
}
